import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Table,
  Tooltip,
} from "antd";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import {
  getRequest,
  getRequest1,
  patchRequest,
  postRequest,
} from "../../axios";
import { authUserData } from "../../utils/Helper";
import { FilterFilled } from "@ant-design/icons";
import { ReactComponent as RupeesSign } from "../../image/RupeesSign.svg";
import ButtonField from "../../common/htmlComponents/ButtonField";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const PreviewAndSendApproval = () => {
  const { t } = useTranslation();
  const { Option } = Select;
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [reload, setReload] = useState(false);
  const [siteName, setSiteName] = useState([]);
  const [materialName, setMaterialName] = useState([]);
  const [enableInputs, setEnableInputs] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const { Search } = Input;
  const [totalCount, settotalCount] = useState(0);
  const [rfqHistory, setRFQHistory] = useState([]);
  const [categoryTree, setCategoryTree] = useState([]);
  const [siteDetails, setSiteDetails] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const formRef = useRef();
  const [totalAm, setTotalAm] = useState(0);
  const [loading, setLoading] = useState(false);

    const pdfContainerRef = useRef(null);
     const buttonRef = useRef(null);
  const [state, setState] = useState({
    // page: 1,
    // ordering: "id",
    // pagesize: 10,
    // search: "",
    // total: 0,
    hide_r0_price: false,
    hide_r1_price: false,
    hide_r_price: false,
    site_id: [],
    material_type_id: [],
  });

  const [hideInitialBidPrice, sethideInitialBidPrice] = useState(false);
  const [hideR1BidPrice, setHideR1BidPrice] = useState(false);
  const [hideRBidPrice, setHideRBidPrice] = useState(false);
  const [showUnitRateCementR1, setShowUnitRateCementR1] = useState(false);
  const [showUnitRateCementR, setShowUnitRateCementR] = useState(false);
  const [isFinalBidPrice, setIsFinalBidPrice] = useState(false);
  const [showAdditionalCheckboxesFinal, setShowAdditionalCheckboxesFinal] =
    useState(true);
  const [showAdditionalCheckboxes, setShowAdditionalCheckboxes] =
    useState(false);
  const [comparativesRFQ, setComparativesRFQ] = useState([]);
  const [rfqNumber, setRfqNumber] = useState(null);
  const [poTotalAmount, setPoTotalAmount] = useState(0);
  const [apiLoading, setapiloading] = useState(false);
  const [floatId, setFloatId] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);

  const [buyer, setBuyer] = useState(null);
  const [firstApprover, setFirstApprover] = useState(null);
  const [secondApprover, setSecondApprover] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  useEffect(() => {
    const getVendorBidRFQ = async () => {
      setapiloading(true);
      try {
        // const response = await getRequest(`po-order/250/get-purchase-order-approval/`);
        const response = await getRequest(
          `po-order/${id}/preview-and-send-for-approval/`
        );

        setFloatId(response.data.data.float_rfq);

        if (response.data.data) {
          setRfqNumber(response.data.data.rfq_number);
          setBuyer(response.data.data.buyer_name);
          setFirstApprover(response.data.data.first_approver_name);
          setSecondApprover(response.data.data.second_approver_name);
          setPoTotalAmount(response?.data?.data?.total_amount);
          setIsCompleted(response?.data?.data?.po_approval);
          // const responseData = response?.data?.data?.site_wise_data;
          const responseData =
            response?.data?.data?.purchase_order_city_details;

          // const tableData = response?.data?.data?.summery_of_price_comparative?.map((item, index) => {

          const tableData = responseData?.map((item, index) => {
            const citySubTotal = item.vendor_city_total.reduce(
              (acc, amount) => acc + amount.amount_with_gst,
              0
            );

            const citySubTotalWithoutGST = item.vendor_city_total.reduce(
              (acc, amount) => acc + amount.amount_without_gst,
              0
            );

            return {
              key: item.po_city_name,
              cityName: item.po_city_name,
              citySubTotal: citySubTotal,
              citySubTotalWithoutGST: citySubTotalWithoutGST,
              comparative: item.purchase_order_site_details.map((com, ind) => {
                const siteSubTotal =
                  com.vendor_site_sub_total[0].amount_without_gst;
                const siteSubTotalWithGST =
                  com.vendor_site_sub_total[0].amount_with_gst;

                return {
                  siteName: com.rfq_site_name,
                  siteId: com.rfq_site_id,
                  siteSubTotal: siteSubTotal,
                  siteSubTotalWithGST: siteSubTotalWithGST,
                  vendorWise: com.po_vendor_detail.map((it, index) => {
                    console.log("itoiy", it);

                    return {
                      vendorName: it.vendor_name,
                      rank: {
                        comparison_ranking: it.comparison_ranking,
                        selected_seasons: it.selected_seasons,
                        other_reason_text: it.other_reason_text
                      },
                      siteLocations: it.po_material_detail.map(
                        (item1, index) => {
                          return {
                            materialName: item1.bid_material_type_name,
                            quantity: item1.bid_material_quantity,
                            uom: item1.bid_uom,
                            r_unit_price: item1.unit_rate,
                            r_total_price: item1.amount_without_gst,
                            total_amount_with_gst: item1.amount_with_gst,
                          };
                        }
                      ),
                    };
                  }),
                };
              }),
            };
          });
          setComparativesRFQ(tableData);

          const poTotalAmount = responseData?.reduce((total, item) => {
            const cityTotal = item.vendor_city_total.reduce(
              (acc, vendor) => acc + vendor.amount_with_gst,
              0
            );
            return total + cityTotal;
          }, 0);

          setPoTotalAmount(poTotalAmount);

          //       const sites = response.data.data.site_wise_data.map(item => ({
          //         id: item.site_id,
          //         name: item.site_name
          //       }));
          //       setSiteName(sites);

          //       const materialTypes = response.data.data.site_wise_data.flatMap(item =>
          //         item.material_wise_data.map(material => ({
          //           id: material.rfq_material_type_id,
          //           name: material.material_name
          //         }))
          //       );

          //       const uniqueMaterialTypes = materialTypes.filter((material, index, self) =>
          //         index === self.findIndex(m => m.id === material.id && m.name === material.name)
          //       );

          //       setMaterialName(uniqueMaterialTypes);

          setapiloading(false);
        } else {
          ErrorNotificationMsg(t("Error in Comparatives"));
          setapiloading(false);
        }
      } catch (error) {
        console.error("Error:", error);
        setapiloading(false);
      }
    };
    getVendorBidRFQ();
  }, [id]);

    const downloadAsPDF = () => {
      if (pdfContainerRef.current) {
          setIsDownloading(true);
          if (buttonRef.current) {
              buttonRef.current.classList.add('hide-in-pdf');
          }
  
          html2canvas(pdfContainerRef.current, {
              useCORS: true,
              scale: 1.5,
              logging: true,
          })
              .then((canvas) => {
                  const imgData = canvas.toDataURL("image/png");
  
                  const pdf = new jsPDF('l', 'mm', 'a4');
                  // const imgProps = pdf.getImageProperties(imgData);
                  // const pdfWidth = pdf.internal.pageSize.getWidth();
                  // const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                  // pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

                  const pdfWidth = pdf.internal.pageSize.getWidth();
                  const pdfHeight = pdf.internal.pageSize.getHeight();
                  const imgProps = pdf.getImageProperties(imgData);
                  const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

                  let heightLeft = imgHeight;
                  let position = 0;

                  // Define the margin (space) to add at the top and bottom of each page
                  const margin = 10; // Adjust this value as needed

                  // Add the first page
                  pdf.addImage(imgData, 'PNG', 0, position + margin, pdfWidth, imgHeight);
                  heightLeft -= (pdfHeight - margin); // Subtract the height of the page minus the margin

                  // Add subsequent pages
                  while (heightLeft >= 0) {
                      pdf.addPage();
                      position = heightLeft - imgHeight; // Calculate the new position for the next page
                      pdf.addImage(imgData, 'PNG', 0, position + margin, pdfWidth, imgHeight);
                      heightLeft -= (pdfHeight - margin); // Update heightLeft for the next iteration
                  }


                  pdf.save(`Preview Approval Order-${rfqNumber}.pdf`);
  
                  if (buttonRef.current) {
                      buttonRef.current.classList.remove('hide-in-pdf');
                  }
                  setIsDownloading(false);
              })
              .catch((error) => {
                  if (buttonRef.current) {
                      buttonRef.current.classList.remove('hide-in-pdf');
                  }
                  setIsDownloading(false);
              });
      } else {
          console.error("PDF container reference is not defined.");
      }
  };

  const handleCheckboxChange = () => {
    setIsFinalBidPrice(!isFinalBidPrice);
    setShowAdditionalCheckboxesFinal(true);

    setState((prevState) => ({
      ...prevState,
      is_final_bid_price: !isFinalBidPrice,
    }));
  };

  const handleCheckboxhideR1 = () => {
    sethideInitialBidPrice(!hideInitialBidPrice);
  };

  const handleCheckboxhideR = () => {
    setHideR1BidPrice(!hideR1BidPrice);
  };

  const handleCheckboxhideRR = () => {
    setHideRBidPrice(!hideRBidPrice);
  };

  const updateState = async () => {
    // try {
    //   const payload = {
    //     ...comparativesRFQ,
    //   }
    //   const response = await patchRequest(`comparative-rfq/${id}/get-comparative-details-by-site-wise/`, payload);
    //   console.log('response 100', response);
    //   if (response.data.data) {
    //     // Update state with the details of the selected site
    //     const responseData = response?.data?.data?.site_wise_data;
    //     const tableData = responseData?.map((item, index) => ({
    //       key: index + item.site_id,
    //       siteName: item?.site_name,
    //       siteLocations: item?.material_wise_data?.map((item1) => ({
    //         materialName: item1?.material_name,
    //         quantity: item1?.total_quantity_by_material,
    //         uom: item1?.material_uom,
    //         vendorBids: item1?.rfq_material_wise_bid_rfq_details?.map((item2) => ({
    //           vendorName: item2?.vendor_name,
    //           r_price: item2?.vendor_bid_rfq_details?.map((item3) => ({
    //             r_unit_price: item3?.r_price?.[0]?.r_unit_price,
    //             r_total_price: item3?.r_price?.[0]?.r_total_price,
    //           })),
    //           r1_price: item2?.vendor_bid_rfq_details?.map((item3) => ({
    //             r1_unit_price: item3?.r1_price?.[0]?.r1_unit_price,
    //             r1_total_price: item3?.r1_price?.[0]?.r1_total_price,
    //           })),
    //           r_price: item2?.vendor_bid_rfq_details?.map((item3) => ({
    //             r_unit_price: item3?.r_price?.[0]?.r_unit_price,
    //             r_total_price: item3?.r_price?.[0]?.r_total_price,
    //           })),
    //         })),
    //       })),
    //     }));
    //     setComparativesRFQ(tableData);
    //     // setComparativesRFQ(response)
    //   } else {
    //     ErrorNotificationMsg(t("Error fetching site details"));
    //   }
    // } catch (error) {
    //   console.error("Failed to fetch data:", error);
    // }
  };

  const handleSiteNameSelectChange = async (value) => {
    const updatedState1 = { ...state, site_id: value };
    setState(updatedState1);

    // if(!initialRender){
    //   updateState();
    // }
  };
  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
    } else {
      updateState();
    }
  }, [state]);

  const handleMaterialSelectChange = async (value) => {
    const updatedState2 = { ...state, material_type_id: value };
    setState(updatedState2);
  };

  const data = comparativesRFQ?.flatMap((item, index) => {
    const citySubTotal = item.citySubTotal || 0;
    return item.comparative.flatMap((comparative, compIndex) => {
      console.log("comparativecomparative", comparative);
      const siteSubTotal = comparative.siteSubTotal || 0;
      const siteSubTotalWithGst =
        comparative.siteSubTotalWithGST?.toLocaleString("en-IN", {
          maximumFractionDigits: 0,
        }) || 0;

      return comparative.vendorWise.flatMap((vendor, vendorIndex) => {
        console.log("vendoreee8", vendor);

        return vendor.siteLocations.flatMap((location, locationIndex) => {
          console.log('locationcx', location);
          
          return [
            {
              key: `${index}-${compIndex}-${vendorIndex}-${locationIndex}`,
              "Sr.No":
                locationIndex === 0 && compIndex === 0 ? `${index + 1}` : null,
              City:
                locationIndex === 0 && compIndex === 0
                  ? `${item.cityName}`
                  : null,
              "Site Name":
                locationIndex === 0 ? `${comparative.siteName}` : null,
              "Vendor Name":
                locationIndex === 0 ? vendor.vendorName || "" : null,
              rank: locationIndex === 0 ? vendor.rank : null,
              other_reason_text: locationIndex === 0 ? vendor.other_reason_text : null,
              Items: `${location.materialName || ""}`,
              Quantity: `${location.quantity || ""}`,
              UOM: `${location.uom || ""}`,
              "Unit Rate": `${`\u20B9 ${
                location.r_unit_price?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                }) || 0
              }`}`,
              "Total Amount": `${`\u20B9 ${
                location.r_total_price?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                }) || 0
              }`}`,
              TotalAmountGST: `${`\u20B9 ${
                location.total_amount_with_gst.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                }) || 0
              }`}`,
            },
            locationIndex === vendor.siteLocations.length - 1 && {
              key: `${index}-${compIndex}-${vendorIndex}-SubTotal`,
              "Site Name": <span className="subtotal1">Sub Total</span>,
              // 'Total Amount':<Input disabled value={`\u20B9 ${siteSubTotal.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`} />,
              "Total Amount": (
                <div className="subtotal1">
                  ₹{" "}
                  {siteSubTotal.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}
                </div>
              ),

              // 'TotalAmountGST': <Input disabled value={`\u20B9 ${siteSubTotalWithGst.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`} className='subtotal' />,

              TotalAmountGST: (
                <div className="subtotal1">
                  {" "}
                  ₹{" "}
                  {siteSubTotalWithGst.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}{" "}
                </div>
              ),
            },

            locationIndex === vendor.siteLocations.length - 1 &&
              compIndex === item.comparative.length - 1 && {
                key: `${index}-CitySubTotal`,
                "Site Name": <span className="citytotal2">City Total</span>,
                // 'Total Amount': <Input disabled value={`\u20B9 ${item.citySubTotalWithoutGST.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`} />,

                "Total Amount": (
                  <div className="citytotal2">
                    ₹{" "}
                    {item.citySubTotalWithoutGST.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}{" "}
                  </div>
                ),

                TotalAmountGST: (
                  <div className="citytotal2">
                    ₹{" "}
                    {citySubTotal.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}
                  </div>
                ),
              },
          ].filter(Boolean);
        });
      });
    });
  });

  const handleUnitRateOfCementChangeR0 = (
    value,
    recordKey,
    siteIndex,
    gstRate,
    quantity
  ) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r_price[0].r_unit_price = value;
    site.vendorBids[0].r_price[0].r_total_price =
      ((value * (100 + gstRate)) / 100) * quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const handleUnitRateOfFreightChangeR0 = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r_price[0].r_unit_price = value;
    site.vendorBids[0].r_price[0].r_total_price = value * site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const handleTotalUnitRateR0Change = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r_price[0].r_total_price = value;
    site.vendorBids[0].r_price[0].r_unit_price = value / site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };
  const [enableInputsR1, setEnableInputsR1] = useState(false);

  const handleUnitRateOfCementChangeR1 = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r1_price[0].r1_unit_price = value;
    site.vendorBids[0].r1_price[0].r1_total_price = value * site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const calculateTotalUnitRateOfCementR1 = (record) => {
    const totalUnitRateOfCementR1 = record.siteLocations.reduce(
      (total, site) =>
        total + (parseFloat(site.vendorBids[0].r1_price[0].r1_unit_price) || 0),
      0
    );
    return totalUnitRateOfCementR1.toFixed(0);
  };

  const handleUnitRateOfFreightChangeR1 = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r1_price[0].r1_unit_price = value;
    site.vendorBids[0].r1_price[0].r1_total_price = value * site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const handleTotalUnitRateOfCementR1Change = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r1_price[0].r1_total_price = value;
    site.vendorBids[0].r1_price[0].r1_unit_price = value / site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };
  const renderUnitRateOfCementR0 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              disabled={enableInputs}
              style={{ marginRight: "10px", width: "300px" }}
              // placeholder={`Enter Unit Rate of Cement for ${site.name}`}
              value={site.vendorBids[0].r_price[0].r_unit_price}
              onChange={(e) =>
                handleUnitRateOfCementChangeR0(
                  e.target.value,
                  record.key,
                  siteIndex,
                  site.vendorBids[0].gst_rate,
                  site.quantity
                )
              }
              type="number"
            />
          ))}
        </div>
      </>
    );
  };

  const vendors = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", gap: "10px" }}>
          {record.siteLocations.map((site, siteIndex) => (
            <div key={siteIndex}>
              {site.vendorBids.map((vendor, vendorIndex) => (
                <>
                  <Input
                    key={vendorIndex}
                    disabled={enableInputs}
                    style={{ marginRight: "10px", width: "150px" }}
                    // placeholder={`Enter Unit Rate of Cement for ${site.name}`}
                    value={vendor.r_price[0].r_unit_price}
                    onChange={(e) =>
                      handleUnitRateOfCementChangeR0(
                        e.target.value,
                        record.key,
                        siteIndex,
                        vendor.gst_rate,
                        site.quantity
                      )
                    }
                    type="number"
                  />
                </>
              ))}
            </div>
          ))}
        </div>
      </>
    );
  };

  const calculateTotalUnitRateOfCementR0 = (record) => {
    const totalUnitRateOfCement = record.siteLocations.reduce(
      (total, site) =>
        total + (parseFloat(site.vendorBids[0].r_price[0].r_unit_price) || 0),
      0
    );
    return totalUnitRateOfCement.toFixed(0);
  };

  const renderUnitRateOfFreightR0 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              disabled={enableInputs}
              style={{ marginRight: "10px", width: "300px" }}
              placeholder={`Enter Unit Rate of Freight for ${site.name}`}
              value={site.vendorBids[0].r_price[0].r_unit_price}
              onChange={(e) =>
                handleUnitRateOfFreightChangeR0(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
        </div>

        <Input
          placeholder={`Total Unit Rate of Freight R0`}
          prefix={<RupeesSign />}
          value={calculateTotalUnitRateOfFreightR0(record)} // Assuming unit_rate_of_cement is a property in the record
          style={{ width: "300px", top: "10px" }} // Adjust width as needed
          disabled
        />
      </>
    );
  };

  const calculateTotalUnitRateOfFreightR0 = (record) => {
    const totalUnitRateOfFreightR0 = record.siteLocations.reduce(
      (total, site) =>
        total + (parseFloat(site.vendorBids[0].r_price[0].r_unit_price) || 0),
      0
    );
    return totalUnitRateOfFreightR0.toFixed(0);
  };

  const calculateTotalUnitRateOfR0 = (record) => {
    const totalUnitRateOfCementR0 =
      parseFloat(calculateTotalUnitRateOfCementR0(record)) || 0;
    const totalUnitRateOfFreightR0 =
      parseFloat(calculateTotalUnitRateOfFreightR0(record)) || 0;

    return (totalUnitRateOfCementR0 + totalUnitRateOfFreightR0).toFixed(0);
  };

  const renderUnitRateOfCementR1 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              prefix={<RupeesSign />}
              disabled={enableInputsR1}
              style={{ marginRight: "10px", width: "300px" }}
              placeholder={`Enter Unit Rate of Cement for ${site.name}`}
              value={site.vendorBids[0].r1_price[0].r1_unit_price}
              onChange={(e) =>
                handleUnitRateOfCementChangeR1(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
        </div>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <Input
            placeholder={`Total Unit Rate of Cement R1`}
            prefix={<RupeesSign />}
            value={calculateTotalUnitRateOfCementR1(record)} // Assuming unit_rate_of_cement is a property in the record
            style={{ width: "300px", top: "10px" }} // Adjust width as needed
            disabled
          />
        </div>
      </>
    );
  };

  const renderUnitRateOfFreightR1 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              prefix={<RupeesSign />}
              disabled={enableInputsR1}
              style={{ marginRight: "10px", width: "300px" }}
              placeholder={`Enter Unit Rate of Freight for ${site.name}`}
              value={site.vendorBids[0].r1_price[0].r1_unit_price}
              onChange={(e) =>
                handleUnitRateOfFreightChangeR1(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
        </div>

        <Input
          placeholder={`Total Unit Rate of Freight R1`}
          prefix={<RupeesSign />}
          value={calculateTotalUnitRateOfFreightR1(record)} // Assuming unit_rate_of_cement is a property in the record
          style={{ width: "300px", top: "10px" }} // Adjust width as needed
          disabled
        />
      </>
    );
  };

  const calculateTotalUnitRateOfFreightR1 = (record) => {
    const totalUnitRateOfFreightR1 = record.siteLocations.reduce(
      (total, site) =>
        total + (parseFloat(site.vendorBids[0].r1_price[0].r1_unit_price) || 0),
      0
    );
    return totalUnitRateOfFreightR1.toFixed(0);
  };

  const renderUnitRateOfTotalUnitRateR1 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              prefix={<RupeesSign />}
              disabled={enableInputsR1}
              style={{ marginRight: "10px", width: "300px" }}
              placeholder={`Enter Total Unit Rate for ${site.name}`}
              value={site.vendorBids[0].r1_price[0].r1_total_price}
              onChange={(e) =>
                handleTotalUnitRateOfCementR1Change(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
        </div>

        <Input
          placeholder={`Total Unit Rate of R1`}
          prefix={<RupeesSign />}
          value={calculateTotalUnitRateOfR1(record)} // Assuming unit_rate_of_cement is a property in the record
          style={{ width: "300px", top: "10px" }} // Adjust width as needed
          disabled
        />
      </>
    );
  };

  const calculateTotalUnitRateOfR1 = (record) => {
    const totalUnitRateOfCementR1 =
      parseFloat(calculateTotalUnitRateOfCementR1(record)) || 0;
    const totalUnitRateOfFreightR1 =
      parseFloat(calculateTotalUnitRateOfFreightR1(record)) || 0;

    return (totalUnitRateOfCementR1 + totalUnitRateOfFreightR1).toFixed(0);
  };

  //console.log('comparativesRFQ ', comparativesRFQ);

  //   const vendorNames = new Set();

  //   comparativesRFQ.forEach(item => {
  //     item.comparative.forEach(item1 => {
  //         item1.siteLocations.forEach(site => {
  //             site.vendorBids.forEach(bid => {
  //                 vendorNames.add(bid.vendorName);
  //             });
  //         });
  //     });
  // });

  // console.log('vendorNames 55', vendorNames);

  //   [...vendorNames].map((vendorName, index) => {
  //     console.log('vendorName 6', vendorName, index);
  //   })

  //   const vendorColumns = [...vendorNames].map((vendorName, vendorIndex) => ({
  //     title: vendorName,
  //     children: [
  //           {
  //             title: 'Unit Price',
  //             dataIndex: 'comparative',
  //             render: (siteLocations, record) => {
  //               console.log('siteLocations 0202 ', siteLocations, 'record ', record);
  //               return (

  //               <>
  //               <>
  //               {siteLocations.map((siteLocation, siteIndex) => (
  //                   <div key={siteIndex}>
  //                       {siteLocation.siteLocations.map((site, siteLocationIndex) => (
  //                           <div key={siteLocationIndex}>
  //                             <Input
  //                             key={siteLocationIndex}
  //                             disabled
  //                             style={{ marginRight: '10px', width: '150px' }}
  //                             // placeholder={`Enter Unit Rate of Cement for ${ven.name}`}
  //                             // value={site.vendorBids[0].r_price[0].r_unit_price}
  //                             value={site.vendorBids.find(bid => bid.vendorName === vendorName)?.r_price[0]?.r_unit_price || ''}

  //                             // value={record.siteLocations.find()}

  //                             type="number"
  //                             />
  //                           </div>
  //                       ))}
  //                   </div>
  //               ))}

  //           </>

  //                 {/*siteLocations.map((site, index) => (
  //                   <div key={index}>
  //                       <div key={index}>
  //                       <Input
  //                       key={index}
  //                       disabled
  //                       style={{ marginRight: '10px', width: '150px' }}
  //                       // placeholder={`Enter Unit Rate of Cement for ${ven.name}`}
  //                       // value={site.vendorBids[0].r_price[0].r_unit_price}
  //                       value={site.vendorBids.find(bid => bid.vendorName === vendorName)?.r_price[0]?.r_unit_price || ''}

  //                       // value={record.siteLocations.find()}

  //                       type="number"
  //                     />
  //                       </div>

  //                   </div>
  //                 )
  //               )*/}
  //               </>
  //             )}

  //           },
  //           {
  //             title: 'Total Amount',
  //             dataIndex: 'comparative',
  //             render: (siteLocations, record) => {
  //               console.log('siteLocations 2343 ', siteLocations, 'record 5', record)
  //               return (
  //               <>
  //               {siteLocations.map((siteLocation, siteIndex) => {
  //                   console.log('siteLocation 0101 ', siteLocation);
  //                 return (
  //                 <>
  //                   <div key={siteIndex}>
  //                       {siteLocation.siteLocations.map((site, siteLocationIndex) => (
  //                           <div key={siteLocationIndex}>
  //                             <Input
  //                             key={siteLocationIndex}
  //                             disabled
  //                             style={{ marginRight: '10px', width: '150px' }}
  //                             // placeholder={`Enter Unit Rate of Cement for ${ven.name}`}
  //                             // value={site.vendorBids[0].r_price[0].r_unit_price}

  //                             value={site.vendorBids.find(bid => bid.vendorName === vendorName)?.r_price[0]?.r_total_price || ''}

  //                             // value={record.siteLocations.find()}

  //                             type="number"
  //                             />

  //                           </div>

  //                       ))}

  //                   </div>
  //                   <div>
  //                   {

  //                     siteLocation.siteLocations.map((o, index) => {
  //                       console.log('vendorName 66', vendorName);
  //                       console.log('o ', o);
  //                       const vendorBid = o.vendorBids.find(bid => bid.vendorName === vendorName);
  //                       console.log('vendorBid ', vendorBid);
  //                       if (vendorBid && index === 0) {
  //                         return (
  //                           <div key={o.key}>
  //                             <Input
  //                               disabled
  //                               style={{ marginRight: '10px', width: '150px' }}
  //                               value={vendorBid.siteTotal}
  //                             />
  //                           </div>
  //                         );
  //                       } else {
  //                         return null; // or some default value if bid for vendor is not found
  //                       }
  //                     })
  //                   }

  //                   {/*
  //                     siteIndex === 1 && (
  //                       <div>
  //                         {record.comparative.map((comparative, index) => {
  //                           console.log('record 66', record);

  //                           const key = record.key;

  //                           // const uniqueRecord = record.filter((rec) => rec.key !== key);

  //                           if (index === 0) {
  //                             return comparative.siteLocations.map((o, index2) => {
  //                               console.log('o 25 ', o);
  //                               const vendorBid = o.vendorBids.find(bid => bid.vendorName === vendorName);
  //                               console.log('vendorBid ', vendorBid);

  //                               if (index2 === 0) {
  //                                 return (
  //                                   <div key={o.key}>
  //                                     <Input
  //                                       disabled
  //                                       style={{ marginRight: '10px', width: '150px' }}
  //                                       value={record.cityTotal[index].citySubTotal}
  //                                     />
  //                                   </div>
  //                                 );
  //                               } else {
  //                                 return null;
  //                               }
  //                             });
  //                           }
  //                           return null;
  //                         })}
  //                       </div>
  //                     )
  //                   */}

  //                   {
  //                     siteIndex === siteLocations.length - 1 && (
  //                       <div>
  //                         {record.cityTotal.map((comparative, index) => {
  //                           console.log('record 66', record);

  //                               if (index === 0) {
  //                                 return (
  //                                   <div key={index}>
  //                                     <Input
  //                                       disabled
  //                                       style={{ marginRight: '10px', width: '150px' }}
  //                                       value={record.cityTotal[vendorIndex].citySubTotal}
  //                                     />
  //                                   </div>
  //                                 );

  //                           }

  //                         })}
  //                       </div>
  //                     )
  //                   }

  //                   {/*siteIndex === 1 && (
  //                     <div>
  //                         {siteLocation.siteLocations.map((o, index) => {
  //                             // console.log('o ', o);
  //                             const vendorBid = o.vendorBids.find(bid => bid.vendorName === vendorName);
  //                             console.log('vendorBid ', vendorBid);
  //                             // Render city subtotal if index is 0
  //                             if (index === 0) {
  //                                 return (
  //                                     <div key={o.key}>
  //                                         <Input
  //                                             disabled
  //                                             style={{ marginRight: '10px', width: '150px' }}
  //                                             value={siteLocation.city_sub_total}
  //                                         />
  //                                     </div>
  //                                 );
  //                             } else {
  //                                 return null;
  //                             }
  //                         })}
  //                     </div>
  //                 )*/}

  //                 </div>

  //                 </>

  //               )
  //               })}
  //               </>
  //             )}
  //           }

  //     ]
  //   }));

  const columns = [
    {
      title: "Sr.",
      dataIndex: "Sr.No",
      width: "30px",
    },
    {
      title: "City",
      dataIndex: "City",
      width: "40px",
    },
    {
      title: "Site",
      dataIndex: "Site Name",
      width: "30px",
    },
    {
      title: "Vendor",
      dataIndex: "Vendor Name",
      width: 120,
    },
    {
      title: "Rank",
      dataIndex: "rank",
      width: 120,
      align: "center",
      render: (text, record) => {
        console.log("texttext", text, "record", record);

        if (text?.comparison_ranking === "L1") {
          return (
            <>
              <Tooltip
                color={"#094E8F"}
                placement="left"
                title={<span style={{ color: "#fff" }}>Lowest Price</span>}
              >
                <p className="lowestven">{text?.comparison_ranking}</p>
              </Tooltip>
              <p style={{ color: "#094E8F", marginTop: "10px" }}>
                {text?.other_reason_text && text?.other_reason_text !== 'N/A' && text?.selected_seasons}
              </p>
            </>
          );
        } else if (text?.comparison_ranking === "L2") {
          return (
            <>
              <Tooltip
                color={"#094E8F"}
                placement="left"
                title={
                  <span style={{ color: "#fff" }}>Second Lowest Price</span>
                }
              >
                <p className="secondLowestven">{text?.comparison_ranking}</p>
              </Tooltip>
              <p style={{ color: "#094E8F", marginTop: "10px" }}>
                {text?.selected_seasons}
              </p>
              <p>
                {
                  text?.other_reason_text && text?.other_reason_text !== 'N/A' && text?.other_reason_text
                }
              </p>
            </>
          );
        } else if (text?.comparison_ranking === "L3") {
          return (
            <>
              <Tooltip
                color={"#094E8F"}
                placement="left"
                title={
                  <span style={{ color: "#fff" }}>Third Lowest Price</span>
                }
              >
                <p className="thirdLowestven">{text?.comparison_ranking}</p>
              </Tooltip>
              <p style={{ color: "#094E8F", marginTop: "10px" }}>
                {text?.selected_seasons}
              </p>
              <p>
                {
                  text?.other_reason_text && text?.other_reason_text
                }
              </p>
            </>
          );
        } else {
          return (
            <>
              <p>{text?.comparison_ranking}</p>
              <p>{text?.selected_seasons}</p>
              <p>
                {
                  text?.other_reason_text && text?.other_reason_text
                }
              </p>
            </>
          );
        }
      },
    },
    {
      title: "Items",
      dataIndex: "Items",
      width: "80px",
    },
    {
      title: "Qty.",
      dataIndex: "Quantity",
      width: "40px",
      align: "center",
    },
    {
      title: "UoM.",
      dataIndex: "UOM",
      width: "40px",
      align: "center",
      render: (text, record) => {
        if (text === "Cubic Meter") {
          return "Cu. Mtr.";
        } else {
          return text;
        }
      },
    },
    {
      title: "Unit Rate",
      dataIndex: "Unit Rate",
      width: "130px",
      align: "right",
    },
    {
      title: (
        <>
          <span>Total Amount</span><br/>
          <span>Without GST</span>
        </>
          ),
      dataIndex: "Total Amount",
      width: "100px",
      align: "right",
      render: (text, record) => {
        if (record["Site Name"] === "Sub Total") {
          return (
            <div style={{ marginRight: "0px" }}>{record["Total Amount"]}</div>
          );
        } else if (record["Site Name"] === "City Sub Total") {
          return (
            <div style={{ marginRight: "0px" }}>{record["Total Amount"]}</div>
          );
        } else {
          return (
            <div style={{ marginRight: "10px" }}>{record["Total Amount"]}</div>
          );
        }
      },
    },
    {
      title: (
        <>
          <span>Total Amount</span><br/>
          <span>With GST</span>
        </>
          ),
      dataIndex: "TotalAmountGST",
      width: "100px",
      align: "right",
      render: (text, record) => {
        if (record["Site Name"] === "Sub Total") {
          return (
            <div style={{ marginRight: "0px" }}>{record["TotalAmountGST"]}</div>
          );
        } else if (record["Site Name"] === "City Sub Total") {
          return (
            <div style={{ marginRight: "0px" }}>{record["TotalAmountGST"]}</div>
          );
        } else {
          return (
            <div style={{ marginRight: "10px" }}>
              {record["TotalAmountGST"]}
            </div>
          );
        }
      },
    },
  ];

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);

      let response;
      response = await postRequest(
        `po-order/${floatId}/send-purchase-order-for-approval/`
      );

      if (response.data.success) {
        // SuccessNotificationMsg(t("PO Order Sent Successfully"));
        SuccessNotificationMsg(response.data.message);

        navigate("/request-for-quotation/history");
        setBtnLoading(false);
      }
    } catch (error) {
      console.log(error);
      setBtnLoading(false);
    }
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Preview and Send for Approval</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/request-for-quotation/history">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Preview and Send for Approval</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                htmlType="PDF"
                label={isDownloading ? "Downloading..." : "Download PDF"}
                
                onClick={downloadAsPDF}
              />
        </div>
      </div>
<div className="stepscontentwrap">
        <div className="stepsContent">
      <section className="grid-sec mt-5" ref={pdfContainerRef}>
        <div className="PR-body" style={{padding:'0'}}>
          <div className="rgq-num-wrap">
            <h5 className="rfq-number new">
              RFQ Number : <span>{rfqNumber}</span>
              {/* RFQ Number : <span>00501</span>*/}
            </h5>
            <div className="btnwrp2">
              {/* <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                // htmlType="Submit"
                label="Download"

              /> */}
              
              {/* <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                htmlType="Excel"
                label="Excel"
                // onClick={handleExcelDownload}
                // icon={<img src={ExelDownload} alt="Plus Square" />}
              /> */}
            </div>
          </div>
          <Spin spinning={apiLoading}>
            <Table
              // dataSource={comparativesRFQ}
              dataSource={data}
              bordered
              scroll={{
                // x: 1000,
                x: "auto",
              }}
              size="middle"
              pagination={false}
              columns={columns}
              className="comparativecustomtbl"
            />
          </Spin>

          <div className="TotalAMT">
            <label>Total Amount: </label>

            <div
              className="citytotalNum"
              style={{ width: "140px", textAlign: "end", fontWeight: "700" }}
            >
              {poTotalAmount
                ? `\u20B9 ${poTotalAmount.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}`
                : 0}
            </div>

            {/* <Input disabled className='InputTotal' value={poTotalAmount ? `\u20B9 ${poTotalAmount.toLocaleString('en-IN', { maximumFractionDigits: 0 })}` : 0}  /> */}
          </div>

          
        </div>
      </section>
      </div>
      <div className="FormFooter bidftr" style={{padding:'16px  ', margin:'0', justifyContent:'space-between', alignItems:'center'}}>
            <div>
              <h5 className="rfq-number new">
                {/* Buyer : <span>{buyer}</span> */}
                Buyer :{" "}
                <span style={{ marginRight: "20px" }}>
                  {buyer ? buyer : "N/A"}
                </span>
                {/* Final Approver :{" "}
                <span style={{ marginRight: "20px" }}>
                  {firstApprover ? firstApprover : "N/A"}
                </span> */}
                {/* Second Approver :{" "}
                <span style={{ marginRight: "20px" }}>
                  {secondApprover ? secondApprover : "N/A"}
                </span> */}
              </h5>
            </div>
            <div className="FormFooter2">
              <ButtonField
                type="primary"
                className="CancelGradiantBtn"
                htmlType="button"
                label={t("Previous")}
                onClick={() =>
                  navigate(
                    `/request-for-quotation/summarypricecomparatives/${id}`
                  )
                }
              />
              {
                isCompleted === false && (
                  <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                label="Send For Approval"
                onClick={handleSubmit}
                loading={btnLoading}
              />
                )
              }
              {
                isCompleted === true && (
                  <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                label="Back to RFQ History"
                onClick={() => navigate("/request-for-quotation/history")}
                loading={btnLoading}
              />
                )
              }
            </div>
          </div>
      </div>
    </>
  );
};

export default PreviewAndSendApproval;
